import Home 								                    from '@/views/Home'

import Dashboard                                from '@/views/dashboard/Home'

// Broker routes
import BrokerHome                               from '@/views/broker/Home'
import BrokerList                               from '@/views/broker/list/Home'
import BrokerAccount                            from '@/views/broker/Account';
import BrokerPassword                           from '@/views/broker/Password';
import BrokerMailSetting                        from '@/views/broker/MailSetting';
import BrokerSiteAppearance                     from '@/views/broker/SiteAppearance';
import BrokerTemplate                           from '@/views/broker/template/Home'
import BrokerLeadCapture                        from '@/views/broker/lead-capture/Home'

import BrokerPayment                            from '@/views/broker/payment/Home'
import BrokerStripe                             from '@/views/broker/payment/stripe/Home'

// Planner routes
import PlannerHome                              from '@/views/planner/list/Home'
import PlannerList                              from '@/views/planner/list/PlannerList'
import PlannerAccount                            from '@/views/planner/Account'
import PlannerPassword                           from '@/views/planner/Password'
import PlannerMailSetting                        from '@/views/planner/MailSetting'
import PlannerPayment                            from '@/views/planner/payment/Home'
import PlannerSiteAppearance                     from '@/views/planner/SiteAppearance'

import StripeList                               from '@/views/stripe/list/Home'

// Metrics routes
import MetricHome                               from '@/views/metric/Home'
import MetricNewBrokersPerWeek                  from '@/views/metric/NewBrokersPerWeek'
import MetricNewClientsPerWeek                  from '@/views/metric/NewClientsPerWeek'
import MetricEmailsToClientsPerWeek             from '@/views/metric/EmailsSentToClientPerWeek'
import MetricEmailsFromClientsPerWeek           from '@/views/metric/EmailsSentFromClientPerWeek'
import MetricStripeSubscriptionsPerWeek         from '@/views/metric/StripeSubscriptionsPerWeek'
import MetricClientResponseRate                 from '@/views/metric/ClientResponseRate'

import UserFeedback                             from '@/views/feedback/Home'


// Auth routes
import AuthLogin									              from '@/views/auth/Login'
import AuthUnauthorized                         from '@/views/auth/Unauthorized'

import PageNotFound		                          from '@/views/PageNotFound'
import LoggedOut                                from '@/views/LoggedOut'

export default [

	// auth related
	{
		path      : '/auth/login',
    name      : 'auth-login',
		component : AuthLogin,
	}, 

  
  {
    path     : '/auth/unauthorized',
    name     : 'auth-unauthorized',
    component: AuthUnauthorized,
  },


  // other pages that are outside of the view/Home
  {
    path     : '/logged-out',
    name     : 'logged-out',
    component: LoggedOut,
  },

  {
    path     : '/', // key is for clients landing on brokerpad from the email
    name     : 'home',
    component: Home,
    meta     : { auth : true },
    children : [

      {
        // planner home
        path     : 'dashboard',
        name     : 'dashboard',
        component: Dashboard,
        meta     : { auth : true },
      },

      {
        // planner home
        path     : 'planner/home',
        name     : 'planner-home',
        component: PlannerHome,
        meta     : { auth : true },
      },

      {
        // list the planners
        path     : 'planner/list',
        name     : 'planner-list',
        component: PlannerList,
        meta     : { auth : true },
      },
      {
        path     : 'planner/list-search/:query/:orderBy/:orderType/:limit/:offset',
        name     : 'planner-list-search',
        component: PlannerList,
        meta     : { auth : true },
      },

      {
        path     : 'planner/:plannerId/account',
        component: PlannerAccount,
        name     : 'planner-account',
        meta     : { auth : true },
      },

      {
        path     : 'planner/:plannerId/password',
        component: PlannerPassword,
        name     : 'planner-password',
        meta     : { auth : true },
      },

      {
        path     : 'planner/:plannerId/site-appearance',
        component: PlannerSiteAppearance,
        name     : 'planner-site-appearance',
        meta     : { auth : true },
      },

      {
        path     : 'planner/:plannerId/mail-setting',
        component: PlannerMailSetting,
        name     : 'planner-mail-setting',
        meta     : { auth : true },
      },

      {
        path     : 'planner/:plannerId/payment',
        component: PlannerPayment,
        name     : 'planner-payment',
        meta     : { auth : true },
      },
      {
        path     : 'broker/home/:showConfirmRegistration?',
        name     : 'broker-home',
        // component: BrokerHome,
        redirect : 'broker/list',
        meta     : { auth : true }
      },
      {
        // list the borkers
        path     : 'broker/list',
        name     : 'broker-list',
        component: BrokerList,
        meta     : { auth : true },
      },

      {
        // list the borkers
        path     : 'broker/list-search/:query/:orderBy/:orderType/:limit/:offset',
        name     : 'broker-list-search',
        component: BrokerList,
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/account',
        component: BrokerAccount,
        name     : 'broker-account',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/password',
        component: BrokerPassword,
        name     : 'broker-password',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/site-appearance',
        component: BrokerSiteAppearance,
        name     : 'broker-site-appearance',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/mail-setting',
        component: BrokerMailSetting,
        name     : 'broker-mail-setting',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/payment',
        component: BrokerPayment,
        name     : 'broker-payment',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/stripe',
        component: BrokerStripe,
        name     : 'broker-stripe',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/template',
        component: BrokerTemplate,
        name     : 'broker-template',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/lead-capture',
        component: BrokerLeadCapture,
        name     : 'broker-lead-capture',
        meta     : { auth : true },
      },




      {
        path     : 'stripe/list',
        name     : 'stripe-list',
        component: StripeList,
        meta     : { auth : true },
      },


      {
        path     : 'feedback/list',
        name     : 'feedback-list',
        component: UserFeedback,
        meta     : { auth : true },
      },
      {
        path     : 'feedback/list-search/:query/:orderBy/:orderType/:limit/:offset',
        name     : 'feedback-list-search',
        component: UserFeedback,
        meta     : { auth : true },
      },

      // Metrics routes
      {
        path     : 'metric/home',
        name     : 'broker-metric-home',
        component: MetricHome,
        meta     : { auth : true },
      },
      {
        path     : 'metric/new-brokers-per-week/:year',
        name     : 'metric-new-brokers-per-week',
        component: MetricNewBrokersPerWeek,
        meta     : { auth : true },
      },
      {
        path     : 'metric/new-clients-per-week/:year',
        name     : 'metric-new-clients-per-week',
        component: MetricNewClientsPerWeek,
        meta     : { auth : true },
      },
      {
        path     : 'metric/emails-to-clients-per-week/:year',
        name     : 'metric-emails-to-clients-per-week',
        component: MetricEmailsToClientsPerWeek,
        meta     : { auth : true },
      },
      {
        path     : 'metric/emails-from-clients-per-week/:year',
        name     : 'metric-emails-from-clients-per-week',
        component: MetricEmailsFromClientsPerWeek,
        meta     : { auth : true },
      },
      {
        path     : 'metric/stripe-subscriptions-per-week/:year',
        name     : 'metric-stripe-subscriptions-per-week',
        component: MetricStripeSubscriptionsPerWeek,
        meta     : { auth : true },
      },
      {
        path     : 'metric/client-response-rate/:year',
        name     : 'metric-client-response-rate',
        component: MetricClientResponseRate,
        meta     : { auth : true },
      },
    ]
  },
]
